"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isItemFieldEdited = exports.isSameItemValue = exports.itemDefaultFields = exports.getPremiumDayType = exports.getIsHoliday = exports.getHolidayName = exports.getNightHours = exports.getIsLateNight = exports.getIsNight = exports.getIsWeekend = exports.getIsSunday = exports.getIsSaturday = exports.getWorkTimeType = exports.getIsOvertime = exports.getIsDoubleTime = exports.getIsTimeAndOneHalf = exports.getIsStraightTime = void 0;
const types_1 = require("@shared/types");
const dayjs_1 = __importDefault(require("dayjs"));
const session_helpers_1 = require("./session-helpers");
const MS_PER_HOUR = 1000 * 60 * 60;
/**
 * Work Time Types by Hours
 */
const getIsStraightTime = (hours) => hours > 0 && hours <= 8;
exports.getIsStraightTime = getIsStraightTime;
const getIsTimeAndOneHalf = (hours) => hours > 8 && hours <= 10;
exports.getIsTimeAndOneHalf = getIsTimeAndOneHalf;
const getIsDoubleTime = (hours) => hours > 10;
exports.getIsDoubleTime = getIsDoubleTime;
const getIsOvertime = (hours) => (0, exports.getIsTimeAndOneHalf)(hours) || (0, exports.getIsDoubleTime)(hours);
exports.getIsOvertime = getIsOvertime;
const getWorkTimeType = (hours, totalMultiplier) => {
    if ((0, exports.getIsTimeAndOneHalf)(hours))
        return types_1.WorkTimeType.TimeAndOneHalf;
    else if ((0, exports.getIsDoubleTime)(hours))
        return totalMultiplier && totalMultiplier + 1 > 2
            ? types_1.WorkTimeType.TimeAndOneHalf
            : types_1.WorkTimeType.DoubleTime;
    else
        return types_1.WorkTimeType.StraightTime;
};
exports.getWorkTimeType = getWorkTimeType;
/**
 * Day of Week
 *
 * Note: moment's `.weekday()` is locale-aware; dayjs's `.day()` is not. Since neither
 * moment nor dayjs ever has a non-default locale set anywhere in this codebase, moment's
 * default `'en'` locale (week starts Sunday) makes `.weekday()` numerically identical to
 * `.day()` here (Sunday=0…Saturday=6), so this is a literal substitution, not an
 * approximation.
 */
const getIsSaturday = (date) => (dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date)).day() === 6;
exports.getIsSaturday = getIsSaturday;
const getIsSunday = (date) => (dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date)).day() === 0;
exports.getIsSunday = getIsSunday;
const getIsWeekend = (date) => (0, exports.getIsSaturday)(date) || (0, exports.getIsSunday)(date);
exports.getIsWeekend = getIsWeekend;
/**
 * Time of Day
 */
const getIsNight = (role, date) => {
    const currentHour = (dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date)).hour();
    return ((currentHour >= 20 && currentHour < 24) ||
        (currentHour >= 0 &&
            currentHour < ((0, session_helpers_1.getIsExtra)(role.performer_type) ? 1 : 6)));
};
exports.getIsNight = getIsNight;
const getIsLateNight = (role, date) => {
    const currentHour = (dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date)).hour();
    return (0, session_helpers_1.getIsExtra)(role.performer_type)
        ? currentHour >= 1 && currentHour < 6
        : false;
};
exports.getIsLateNight = getIsLateNight;
const getNightHours = (activity) => {
    const nightStart = (0, dayjs_1.default)(activity.start_time)
        .hour(20)
        .minute(0)
        .second(0)
        .millisecond(0);
    return (0, dayjs_1.default)(activity.end_time).diff(nightStart) / MS_PER_HOUR;
};
exports.getNightHours = getNightHours;
/**
 * Holidays
 */
/** The holiday a date falls on (Talon's list, holidayDates), or undefined */
const getHolidayName = (date) => {
    date = dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date);
    // holidayDates counts months from 1; dayjs from 0
    const month = date.month() + 1;
    const dayOfMonth = date.date();
    const weekday = date.day();
    return types_1.holidayDates[month]?.find((holiday) => holiday.day
        ? holiday.day === dayOfMonth
        : !!holiday.days &&
            dayOfMonth >= holiday.days[0] &&
            dayOfMonth <= holiday.days[1] &&
            holiday.weekday === weekday)?.name;
};
exports.getHolidayName = getHolidayName;
const getIsHoliday = (date) => !!(0, exports.getHolidayName)(date);
exports.getIsHoliday = getIsHoliday;
/**
 * The premium day a date falls on: a holiday, or else a Saturday or Sunday. A holiday on a weekend is a holiday,
 * so work on it is paid one premium, not two.
 */
const getPremiumDayType = (date) => {
    date = dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date);
    if ((0, exports.getIsHoliday)(date))
        return types_1.SessionDayType.Holiday;
    if (date.day() === 6)
        return types_1.SessionDayType.Saturday;
    if (date.day() === 0)
        return types_1.SessionDayType.Sunday;
    return undefined;
};
exports.getPremiumDayType = getPremiumDayType;
/**
 * Estimate items: whether a value was edited by hand, i.e. differs from the contract's. Rates within half a
 * cent, and multipliers within a millionth, count as the same: the web sends back percentages it has
 * rounded (19.95% -> 0.19949999999999998).
 */
exports.itemDefaultFields = [
    'rate',
    'p_and_h_multiplier',
    'handling_multiplier',
    'taxes_multiplier',
];
const isSameItemValue = (field, a, b) => Math.abs((a ?? 0) - (b ?? 0)) <= (field === 'rate' ? 0.005 : 1e-6);
exports.isSameItemValue = isSameItemValue;
const isItemFieldEdited = (item, field) => !!item.defaults && !(0, exports.isSameItemValue)(field, item[field], item.defaults[field]);
exports.isItemFieldEdited = isItemFieldEdited;
//# sourceMappingURL=estimate-helpers.js.map